@if(!isLandingPage){
<div class="profile-activities-container">
    @if (!isThirdParty) {
    <app-user-authenticated [class.highlighted]="highlightedSection === 'user authenticated'"></app-user-authenticated>
    } @for (card of visibleCards; track card.name) {
    <app-card-outlet
        [class.sticky-card]="card.name === 'policy-number'"
        [component]="card.component"
        [inputs]="getInputs(card)"
        [outputs]="card.outputs || {}"
        [highlighted]="isCardHighlighted(card)"
        (outputEvent)="onCardOutput(card, $event)"
        (click)="onCardClick(card)"
    ></app-card-outlet>
    }
    <!-- @if (!isThirdParty) { 
                @for (field of fields; track field) {
                <app-desktop-list-view
                    [data]="field"
                    [attr.id]="field.name"
                    [class.highlighted]="(selectedSection$ | async) === field.name"
                ></app-desktop-list-view>
            } 
        } -->
</div>
}
